var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{class:[
      'g-cursor',
      { 'g-cursor_hover': _vm.hover },
      { 'g-cursor_hide': _vm.hideCursor }
    ]},[_c('div',{staticClass:"g-cursor__circle",style:(_vm.cursorCircle)}),_c('div',{ref:"point",staticClass:"g-cursor__point",style:(_vm.cursorPoint)})]),(_vm.loadState)?_c('Loader',{attrs:{"loaded":_vm.loaded}}):_vm._e(),_c('Menu'),_c('div',{staticClass:"full-home initial-display"},[_c('Home',{attrs:{"id":"Home"}}),_c('Projects',{attrs:{"id":"Projects"}}),_c('About'),_c('Contact'),_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }